import {Grid} from '@logistics-frontend/blocks'
import {HeaderButton} from '@logistics-frontend/order-layout-blocks'
import React from 'react'

import {i18n} from '../../config'

function NavLinks() {
  return (
    <Grid alignItems="flex-start" container>
      <Grid direction="column" justify="flex-start" container item xs>
        <Grid item xs>
          <HeaderButton size="s" variant="pseudo" active transparent>
            {i18n('order.footer.link.business', 'Бизнесу')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/payment/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.link.become-a-client', 'Стать клиентом')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton
            href="https://passport.yandex.ru/auth/list?retpath=https%3A%2F%2Fdostavka.yandex.ru%2Fauth&origin=b2b_dostavka"
            size="s"
            variant="pseudo"
            transparent
          >
            {i18n('order.footer.link.enter-to-personal-account', 'Войти в личный кабинет')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="mailto:help@dostavka.yandex.ru" size="s" variant="pseudo" transparent>
            {i18n('order.footer.link.contact-support', 'Написать в поддержку')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/about/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.link.business', 'О компании')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/referral/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.link.become-a-client', 'Реферальная программа')}
          </HeaderButton>
        </Grid>
      </Grid>
      <Grid direction="column" justify="flex-start" container item xs>
        <Grid item xs>
          <HeaderButton size="s" variant="pseudo" active transparent>
            {i18n('order.footer.link.for-users', 'Пользователям')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/tracking/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.link.track-parcel', 'Отследить посылку')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="mailto:support.taxi@go.yandex.ru" size="s" variant="pseudo" transparent>
            {i18n('order.footer.link.contact-support', 'Написать в поддержку')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/safety/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.fraud-protection', 'Как защититься от мошенников')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/insurance/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.how-insurance-works', 'Как работает страховка')}
          </HeaderButton>
        </Grid>
      </Grid>
      <Grid direction="column" justify="flex-start" size="s" container item xs>
        <Grid item xs>
          <HeaderButton size="s" variant="pseudo" active transparent>
            {i18n('order.footer.for-courier', 'Курьерам')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/for-courier/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.become-driver-or-courier', 'Стать пешим курьером или автокурьером')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/for-driver/personal-cargo/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.become-a-cargo-driver', 'Стать водителем грузовой машины')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton
            href="https://pro.yandex.ru/ru-ru/moskva/knowledge-base"
            rel="noreferrer"
            size="s"
            target="_blank"
            variant="pseudo"
            transparent
          >
            {i18n('order.footer.know-base', 'База знаний для курьеров')}
          </HeaderButton>
        </Grid>
      </Grid>
      <Grid direction="column" container item xs>
        <Grid item xs>
          <HeaderButton size="s" variant="pseudo" active transparent>
            {i18n('order.footer.carrier-at-delivery', 'Карьера в Доставке')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/careers/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.about', 'Немного про Доставку')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/careers/jobs/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.vacancies', 'Вакансии')}
          </HeaderButton>
        </Grid>
      </Grid>
      <Grid direction="column" container item xs>
        <Grid item xs>
          <HeaderButton size="s" variant="pseudo" active transparent>
            {i18n('order.footer.delivery-at-your-city', 'Доставка в вашем городе')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/region/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.order-delivery-right-now', 'Заказать доставку прямо сейчас')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/express-delivery/region/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.express-delivery', 'Экспресс-доставка')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/courier/region/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.courier-delivery', 'Курьерская доставка')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/cargo/region/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.cargo-delivery', 'Грузовая доставка')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/next-day-delivery/region/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.next-day-delivery', 'Доставка на следующий день')}
          </HeaderButton>
        </Grid>
        <Grid item xs>
          <HeaderButton href="/24-hours/" size="s" variant="pseudo" transparent>
            {i18n('order.footer.all-day-delivery', 'Круглосуточная доставка')}
          </HeaderButton>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default NavLinks
